import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import ConfirmModal from "../../../../uq-ui/components/confirm-modal";
import { draftContinueModalVisibilitySelector } from '../../../store/drafts/selectors';
import { continueDraft, startFreshSticker } from '../../../store/drafts/actions';
import { isMemorialType } from "../../../store/sticker-show/selectors";

class StickersComponentsDraftContinueModal extends Component {
  
  render() {
    return (
      <ConfirmModal
        show={this.props.showModal}
        title={this.props.t('title')}
        confirmLabel={this.props.t('continueDraft')}
        cancelLabel={this.props.t('startFresh')}
        showCancelBtn={true}
        confirmBtnStyles={{ width: '80%' }}
        cancelBtnStyles={{ width: '80%' }}
        onCancel={this.props.startFreshSticker}
        onConfirm={this.props.continueDraft}
        onClose={this.props.continueDraft}
        isMemorialTheme={ this.props.isMemorialTheme }>
        {this.props.t('message')}
      </ConfirmModal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showModal: draftContinueModalVisibilitySelector(state),
    isMemorialTheme: isMemorialType(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    startFreshSticker: () => dispatch(startFreshSticker()),
    continueDraft: () => dispatch(continueDraft())
  }
};

export default compose(
  withTranslation('cmp-draft-continue'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersComponentsDraftContinueModal);


// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/draft-continue-modal/index.jsx